import tmsApi from './../api/tmsApi';
import helper from './helper';

const { getActiveParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      companies: 'LOADING',
    },
    companies: [],
    detailData: null,
    detailDataId: null,
    dataLoaded: false,
    count_info: {
      all: 0,
      customer: 0,
      active: 0,
      inactive: 0,
    },
    query: {
      search: '',
      page: {
        number: 1,
        count: 10,
      },
      sort: {
        by: 'NAME',
        direction: 'ASC',
      },
      type: 'CUSTOMER',
      active: 'all',
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.companies.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.companies.push(data);
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.page.number = 1;
      query.page.count = 10;
      query.sort.by = 'NAME';
      query.sort.direction = 'ASC';
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count = 10) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      state.count_info.customer = 0;
      state.count_info.active = 0;
      state.count_info.inactive = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
        if (c.type === 'CUSTOMER') {
          state.count_info.customer += c.count;
        }
        if (c.active) {
          state.count_info.active += c.count;
        } else {
          state.count_info.inactive += c.count;
        }
      }, this);
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.companies.findIndex(cmp => cmp.id === id);
      state.companies.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_COMPANIES({ dataState }, state) {
      dataState.companies = state;
    },
  },
  getters: {
    companies(state) {
      return state.companies;
    },
    userCompany(state, getters, rootState) {
      const userData = rootState.userData || {};
      const company = userData.company || {};

      return company;
    },
    customers(state, getters) {
      const customerIds = getters.userCompany._customerIds || []; // eslint-disable-line

      return state.companies
        .filter(c => customerIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    tenants(state, getters) {
      const tenantIds = getters.userCompany._tenantIds || []; // eslint-disable-line

      return state.companies
        .filter(c => tenantIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    count_all(state) {
      return state.count_info.all;
    },
    count_customer(state) {
      return state.count_info.customer;
    },
    count_active(state) {
      return state.count_info.active;
    },
    count_inactive(state) {
      return state.count_info.inactive;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    dataStateCompanies(state) {
      return state.dataState.companies;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const active = getActiveParam(state);
      const type = `type: ${state.query.type}`;
      const query = `
        {
          companies(
            offset: ${offset},
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${type}
            ${active}
          ) {
            id
            type
            name
            namespace
            active
            partners {
              type
              company {
                id
                name
              }
              expiration_date
            }
            parent {
              id
              name
            }
            subsidiaries {
              id
              name
              type
              active
            }
            created_at
            metadata
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_COMPANIES', 'LOADING');
      return api(query, 'companies').then(({ data }) => {
        const { companies } = data;
        companies.forEach((company) => {
          commit('ADD_DATA_ON_LIST', company);
        }, this);
        commit('SET_DATA_LOADED');
      }).then(() => {
        setTimeout(() => commit('SET_DATA_COMPANIES', 'LOADED'), 500);
      }).catch(() => {
        commit('SET_DATA_COMPANIES', 'ERROR');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          company_info(query: "${state.query.search}") {
            type
            active
            count
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'company_info').then(({ data }) => {
        const { company_info } = data;
        commit('SET_COUNT_INFO', company_info);
      }).catch(() => {
        commit('SET_ERROR', 'LOAD_INFO');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const active = getActiveParam(state);
      const type = `type: ${state.query.type}`;
      const query = `
        {
          companies: find_companies(
            query: "${state.query.search}",
            offset: ${offset},
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${type}
            ${active}
          ) {
            id
            type
            name
            namespace
            active
            created_at
            parent {
              id
              name
            }
            subsidiaries {
              id
              name
              type
              active
            }
            metadata
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'find_companies').then(({ data }) => {
        const { companies } = data;
        companies.forEach((company) => {
          commit('ADD_DATA_ON_LIST', company);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('SET_ERROR', 'FIND_DATA');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          company(id: ${state.detailDataId}) {
            id
            name
            namespace
            type
            active
            address {
              country
              state
              city
              address1
              address2
              zip_code
              latitude
              longitude
            }
            partners {
              type
              company {
                id
                name
              }
              expiration_date
            }
            parent {
              id
              name
            }
            subsidiaries {
              id
              name
              type
              active
            }
            metadata
          }
        }
      `;
      return api(query, 'company').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.company);
      }).catch(() => {
        commit('SET_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    FREE_SEARCH_DATA({ state, rootState, commit }, querySearch) {
      const api = tmsApi.buildRetry(rootState.token);
      const { value } = querySearch;
      const type = `type: ${state.query.type}`;
      const query = `{
        companies: find_companies(
          query: "${value}",
          ${type}
        ) {
          id
          name
          type
          active
        }
      }`;

      return api(query, 'search_company').catch(() => {
        commit('ADD_ERROR', 'FREE_SEARCH_DATA');
      });
    },
    LOAD_SIMPLE_DATA({ state, rootState }, payloads) {
      const api = tmsApi.buildRetry(rootState.token);
      const typeData = payloads.tenants === 1 ? 'tenants' : 'companies';
      const type = `type: ${state.query.type}`;
      const query = `
        {
          companies: ${typeData}(
            sort: {
              by: NAME
              direction: ASC
            },
            ${type}
          ) {
            id
            name
            type
          }
        }
      `;
      return api(query, typeData).then(({ data }) => {
        const { companies } = data;
        return companies;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/customers.js